import { Spinner } from '@platform/elements';
import React from 'react';

import styles from './IntentLoadingSpinner.module.scss';

export function IntentLoadingSpinner(): React.ReactElement {
  return <Spinner className={styles.spinner} />;
}
